import { useState, useEffect } from 'react';
import API from '../../../api/API';
import { applicaStatistiche } from '../utils/matchUtils';

export const useMatchData = (searchParams, id, matchForm, useMatchAPIHook) => {
  const [loading, setLoading] = useState(true);
  const { caricaCoppia } = useMatchAPIHook;

  // Unico punto in cui la pagina si porta in casa una partita: le due distinte e, se esiste, il
  // punteggio. Prima le tre strade (apertura per id, parametri dal planning, scelta dalle
  // tendine) facevano ognuna la sua sequenza di chiamate e riempivano il form in modo diverso.
  const caricaPartita = async (s1Id, s2Id, tipo = null, nome = null) => {
    const editor = await caricaCoppia(s1Id, s2Id, tipo, nome);
    if (!editor || !editor.squadra1 || !editor.squadra2) {
      return null;
    }

    matchForm.setSquadra1({ id: editor.squadra1.id, nome: editor.squadra1.nome });
    matchForm.setSquadra2({ id: editor.squadra2.id, nome: editor.squadra2.nome });
    matchForm.setGiocatoriSquadra1(applicaStatistiche(editor.squadra1.giocatori, editor.statistiche));
    matchForm.setGiocatoriSquadra2(applicaStatistiche(editor.squadra2.giocatori, editor.statistiche));
    matchForm.setFalli1(editor.falli1 || 0);
    matchForm.setFalli2(editor.falli2 || 0);

    // ?? e non ||: uno zero e' un voto assegnato, e || lo scambierebbe per una casella vuota
    matchForm.setFairPlay1(editor.fairPlay1 ?? null);
    matchForm.setFairPlay2(editor.fairPlay2 ?? null);

    // id a zero vuol dire che la partita non e' ancora stata salvata
    const esiste = (editor.id || 0) > 0;
    matchForm.setIsEditMode(esiste);
    matchForm.setPartitaCorrente(esiste
      ? {
          id: editor.id,
          squadra1: editor.squadra1.id,
          squadra2: editor.squadra2.id,
          tipo: editor.tipo,
          nome: editor.nome
        }
      : null);

    if (esiste && editor.tipo) {
      matchForm.setTipoPartita(editor.tipo);
    }

    return editor;
  };

  const loadExistingMatch = async (matchId) => {
    const response = await API.partite.get(matchId);
    if (!response || !response.isSuccess || !response.data) {
      return;
    }

    const partita = response.data;
    if (!partita.s1 || !partita.s2) {
      console.error('La partita non riporta le due squadre:', partita);
      return;
    }

    // la fascia non e' conservata su partita: la tendina riparte dal default
    matchForm.setFasciaPartita(partita.fascia || 'prima');

    await caricaPartita(partita.s1, partita.s2, partita.tipo, partita.nome);
  };

  const handlePlanningParameters = async () => {
    const squadra1Id = searchParams.get('squadra1Id');
    const squadra2Id = searchParams.get('squadra2Id');
    const tipo = searchParams.get('tipo');
    const nome = searchParams.get('nome');
    const fascia = searchParams.get('fascia');
    const readonly = searchParams.get('readonly') === 'true';

    if (!squadra1Id || !squadra2Id || !readonly) {
      return;
    }

    matchForm.setIsReadonly(true);
    if (tipo) {
      matchForm.setTipoPartita(tipo.toLowerCase());
    }
    matchForm.setFasciaPartita(fascia || 'prima');

    await caricaPartita(parseInt(squadra1Id), parseInt(squadra2Id), tipo, nome);
  };

  const loadData = async () => {
    setLoading(true);

    try {
      const storedEdition = localStorage.getItem('selectedEdition');
      if (storedEdition) {
        const edizione = JSON.parse(storedEdition);
        matchForm.setEdizioneSelezionata(edizione);

        // Solo id e nome, per le tendine: le distinte arrivano dall'endpoint editor, una volta
        // che si sa quali sono le due squadre in campo.
        const response = await API.accettazione.elenco(edizione.id);
        if (response && response.data) {
          matchForm.setSquadreDisponibili(response.data);
        }

        if (id) {
          await loadExistingMatch(id);
        } else {
          await handlePlanningParameters();
        }
      }
    } catch (error) {
      console.error('Errore nel caricamento dei dati:', error);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, [searchParams, id]);

  return {
    loading,
    loadData,
    caricaPartita
  };
};
